module.exports = __webpack_public_path__ + "static/img/art-rooney-sportsmanship-award.7ce3e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/art-rooney-sportsmanship-award.png
// module id = dw6O
// module chunks = 1